import { Moment } from "moment-timezone";
import React from "react";
import DateHeaderCell from "./DateHeaderCell";
import { classNames } from "../../helpers";
import { ChevronLeftIcon } from "@heroicons/react/outline";
import { useTranslation } from "react-i18next";

type DateHeaderContainerProps = {
  datesList: { date: Moment; isDisabled: boolean }[];
  onSelectDay?: (date: Moment) => void;
  selectedDate?: Moment | null;
  className?: string;
};
export default function DateHeaderContainerSlider(
  props: DateHeaderContainerProps
) {
  const { datesList, onSelectDay, selectedDate, className } = props;
  const ref = React.useRef<HTMLDivElement>();
  const { i18n } = useTranslation();
  const scrollToNext = () => {
    if (!!ref.current) {
      if (i18n.language === "en") {
        ref.current.scrollBy({
          left: 300,
          behavior: "smooth",
        });
      } else {
        ref.current.scrollBy({
          left: -300,
          behavior: "smooth",
        });
      }
    }
  };
  const scrollToPrev = () => {
    if (!!ref.current) {
      if (i18n.language === "en") {
        ref.current.scrollBy({
          left: -200,
          behavior: "smooth",
        });
      } else {
        ref.current.scrollBy({
          left: 200,
          behavior: "smooth",
        });
      }
    }
  };
  return (
    <div className="w-full flex justify-between">
      <button
        className="  bg-white-gradient px-1"
        onClick={() => scrollToPrev()}
      >
        <ChevronLeftIcon className="w-5 h-5 rotate-180 ltr:rotate-0 text-gray-400" />
      </button>
      <div
        className={classNames(
          " gap-2 no-scrollbar",
          !!className ? className : "grid grid-cols-7"
        )}
        ref={ref as React.MutableRefObject<HTMLDivElement>}
      >
        {React.Children.toArray(
          datesList.map(({ date, isDisabled }) => (
            <DateHeaderCell
              date={date}
              isSelected={date.isSame(selectedDate, "day")}
              isDisabled={isDisabled}
              onSelectDay={onSelectDay}
              className={"min-w-[102.86px]"}
            />
          ))
        )}
      </div>
      <button
        className=" bg-white-gradient px-1"
        onClick={() => scrollToNext()}
      >
        <ChevronLeftIcon className="w-5 h-5 ltr:rotate-180  text-gray-400" />
      </button>
    </div>
  );
}
